//

export const apiEndpoint = (x: string) => "https://api.stock.selects.jp" + x;
//export const apiEndpoint = (x: string) => "http://192.168.0.147:8090" + x;
